import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map, type Observable } from 'rxjs';
import type { LocationItem } from '../models/location-item.model';
import type { LocationItemModel as ServerLocationItem } from '../models/middleware/location-item.model';
import type { MultiItemResponse } from '../models/middleware/multi-item-response.model';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  private readonly http = inject(HttpClient);
  private readonly url = '/api/authenticated/locations';

  getLocationsForEvent(eventId: string): Observable<LocationItem[]> {
    return this.http
      .get<MultiItemResponse<ServerLocationItem>>(this.url, { params: { event: eventId } })
      .pipe(map((response) => response.items.map((location) => this.mapToLocationItem(location))));
  }

  private mapToLocationItem(model: ServerLocationItem): LocationItem {
    return {
      id: model.id,
      documentId: model.documentId,
      eventIds: model.eventIds,
      name: model.name,
      description: model.description,
      coordinates: model.coordinates,
      imageUrl: model.imageUrl,
      address: model.address,
    };
  }
}
